import trans from './img/shopE.png';
import pdf from './img/pdf.png';
import './index.css';
import { saveAs } from 'file-saver';
const Part = ({language}) => {
    const translate = {
        prase1:{
            eng: "Since the programs are coded using the TROPHY-ACCESS 3.0 conditional access system, you will need a special T2/S2 Set-Top-Box. To receive MVDS (DVB-S2) channels, you need a 0.4 m - 0.6 m satellite antenna with a universal LNB.",
            fra: "Étant donné que les programmes sont codés à l'aide du système d'accès conditionnel TROPHY-ACCESS 3.0, vous aurez besoin d'un décodeur T2/S2 spécial. Pour recevoir les chaînes MVDS (DVB-S2), vous avez besoin d'une antenne satellite d'un diamètre de 0,4 m - 0,6 m avec un LNB universel."          
        },
        prase2:{
            eng: "The Set-Top-Box can be purchased in the online store. Click on the Set-Top-Box image to go to the e-shop page:",
            fra: "Le décodeur peut être acheté dans la boutique en ligne. Cliquez sur l'image du décodeur pour accéder à la page de la boutique:"            
        },
        ytLinks:{
            eng: "https://www.youtube.com/embed/mWG2tQcrsQU?si=SJeihHfU74EsGKhq",
            fra: "https://www.youtube.com/embed/zjxVGiTKTFA?si=hMu9PIy-pbiRtbJC"
        },
    }

    const handleDownload = () => {
        let pdfPath = process.env.PUBLIC_URL;
        if(language == "eng"){
            pdfPath += '/static/pdfs/TROPHY_TA_1006HD_User_Manual_en.pdf';
        }else{
            pdfPath += '/static/pdfs/TROPHY_TA_1006HD_User_Manual_fr.pdf';
        }
        saveAs(pdfPath, 'User_manual.pdf');
    };

    return <> 
      <div>
          <p>{translate.prase1[language]}</p>
          {/* <p>{translate.prase2[language]}</p>     */}
      </div>
      <div className="device-info-wrapper">
        <img src={trans} alt="TV Box" className="device-image" />

        <button onClick={handleDownload} className="pdf-download-btn">
          <img src={pdf} alt="PDF Icon" className="pdf-icon" />
          <span>Download</span>
        </button>
      </div>
      <div className="video-responsive">
        <iframe
          src={translate.ytLinks[language]}
          title="YouTube video"
          allowFullScreen
        />
      </div>
  </>
}

export default Part;